module.exports = __webpack_public_path__ + "img/pauli-y-root-dagger-22.be3b49d3.svg";